export class CancellationVM {
  dateModal: string;

  constructor(dateModal: string) {
    this.dateModal = dateModal;
  }
}
